import type { AnalysisDetails, AnalysisMetric } from "./Analysis";
import type { FindingCategory } from "./Finding";

// Метрики секции из подробностей разбора. Пусто у разборов, сделанных до секций у метрик:
// тогда секция показывает находки-метрики карточками, как раньше.
export const sectionMetrics = (
  details: AnalysisDetails | null,
  category: FindingCategory,
): AnalysisMetric[] => details?.metrics.filter((metric) => metric.category === category) ?? [];
